<div class="container-fluid admin-page cars-page">
    <header class="admin-page-header">
        <div>
            <h1>{{ 'Cars' | translate }}</h1>
            <p>{{ 'Select a car to inspect status, driver assignments, pairing and service settings.' | translate }}</p>
        </div>
        <div class="admin-header-actions">
            <button (click)="exportData()" *ngIf="canExportData" class="admin-primary-button" type="button">
                <i class="material-icons">file_download</i><span>{{ 'Export all data' | translate }}</span>
            </button>
            <button (click)="getCarsData()" [disabled]="isCarsRequestInProgress"
                    class="admin-refresh-button" type="button">
                <i class="material-icons">refresh</i><span>{{ 'Refresh' | translate }}</span>
            </button>
        </div>
    </header>

    <div class="admin-toolbar">
        <label class="admin-search-field">
            <span>{{ 'Search cars' | translate }}</span>
            <div class="admin-search-input">
                <i class="material-icons">search</i>
                <input (ngModelChange)="onSearchTextChanged($event)" [ngModel]="searchText"
                       [placeholder]="'Search by car ID, number, app version or driver' | translate" type="search">
            </div>
        </label>
        <label class="admin-filter-field">
            <span>{{ 'City' | translate }}</span>
            <select (ngModelChange)="onCityFilterChanged($event)" [ngModel]="cityFilter">
                <option value="">{{ 'All cities' | translate }}</option>
                <option *ngFor="let city of getCityOptions()" [value]="city">{{ city }}</option>
            </select>
        </label>
        <label class="admin-filter-field">
            <span>{{ 'Company' | translate }}</span>
            <select (ngModelChange)="onCompanyFilterChanged($event)" [ngModel]="companyFilter">
                <option value="">{{ 'All companies' | translate }}</option>
                <option *ngFor="let company of getCompanyOptions()" [value]="company">{{ company }}</option>
            </select>
        </label>
        <label class="admin-filter-field">
            <span>{{ 'Suspended' | translate }}</span>
            <select (ngModelChange)="onSuspendedFilterChanged($event)" [ngModel]="suspendedFilter">
                <option value="">{{ 'All' | translate }}</option>
                <option value="true">{{ 'Yes' | translate }}</option>
                <option value="false">{{ 'No' | translate }}</option>
            </select>
        </label>
        <label class="admin-page-size">
            <span>{{ 'Rows' | translate }}</span>
            <select (ngModelChange)="changePageSize()" [(ngModel)]="pageSize">
                <option [ngValue]="10">10</option>
                <option [ngValue]="25">25</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>
            </select>
        </label>
    </div>

    <div *ngIf="isLoadingCars" class="loading-state">
        <div class="loading-spinner"></div>
        <span>{{ 'Loading cars...' | translate }}</span>
    </div>

    <ng-container *ngIf="!isLoadingCars">
        <div *ngIf="filteredCarsData.length > 0" class="cars-table-wrap admin-data-table-wrap">
            <table class="cars-table admin-data-table">
                <thead>
                <tr>
                    <th [attr.aria-sort]="tableSort.getAriaSort('carId')">
                        <button (click)="tableSort.toggle('carId')" class="admin-sort-button" type="button">
                            <span>{{ 'Car ID' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('carId', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('carId', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('carNumber')">
                        <button (click)="tableSort.toggle('carNumber')" class="admin-sort-button" type="button">
                            <span>{{ 'Car number' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('carNumber', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('carNumber', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('city')">
                        <button (click)="tableSort.toggle('city')" class="admin-sort-button" type="button">
                            <span>{{ 'City' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('city', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('city', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('company')">
                        <button (click)="tableSort.toggle('company')" class="admin-sort-button" type="button">
                            <span>{{ 'Company' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('company', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('company', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('lastLogin')">
                        <button (click)="tableSort.toggle('lastLogin')" class="admin-sort-button" type="button">
                            <span>{{ 'Last login' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('lastLogin', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('lastLogin', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('suspended')">
                        <button (click)="tableSort.toggle('suspended')" class="admin-sort-button" type="button">
                            <span>{{ 'Suspended' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('suspended', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('suspended', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('drivers')">
                        <button (click)="tableSort.toggle('drivers')" class="admin-sort-button" type="button">
                            <span>{{ 'Drivers' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('drivers', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('drivers', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr (click)="showCarDetails(item)" (keydown.enter)="showCarDetails(item)"
                    *ngFor="let item of getPagedCars()" tabindex="0">
                    <td [attr.data-label]="'Car ID' | translate"><strong>{{ item.CarId }}</strong></td>
                    <td [attr.data-label]="'Car number' | translate">{{ item.CarNumber || '-' }}</td>
                    <td [attr.data-label]="'City' | translate">{{ item.CityName || '-' }}</td>
                    <td [attr.data-label]="'Company' | translate">{{ item.CompanyName || '-' }}</td>
                    <td [attr.data-label]="'Last login' | translate">{{ (item.LastLoginAsString || 'never') | translate }}</td>
                    <td [attr.data-label]="'Suspended' | translate">
                        <strong [class.status-danger]="item.Suspension && item.Suspension.IsSuspended"
                                [class.status-ok]="!item.Suspension || !item.Suspension.IsSuspended"
                                class="status-pill">
                            {{ (item.Suspension && item.Suspension.IsSuspended ? 'Yes' : 'No') | translate }}
                        </strong>
                    </td>
                    <td [attr.data-label]="'Drivers' | translate">
                        <div *ngIf="item.Drivers && item.Drivers.length > 0" class="drivers-stack">
                            <span *ngFor="let driver of item.Drivers">{{ driver.DriverName || '-' }}</span>
                        </div>
                        <span *ngIf="!item.Drivers || item.Drivers.length === 0">-</span>
                    </td>
                    <td class="details-cell">
                        <button (click)="showCarDetails(item); $event.stopPropagation()"
                                [attr.aria-label]="'Open car details' | translate"
                                class="details-button" type="button">
                            <i class="material-icons">chevron_right</i>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div *ngIf="filteredCarsData.length === 0" class="empty-state">
            <i class="material-icons">search_off</i>
            <span>{{ 'No cars match the current search or filters.' | translate }}</span>
        </div>

        <footer *ngIf="filteredCarsData.length > 0" class="admin-pagination">
            <span class="admin-pagination-summary">
                {{ 'Showing' | translate }} {{ getVisibleRangeStart() }}-{{ getVisibleRangeEnd() }}
                {{ 'of' | translate }} {{ filteredCarsData.length }} {{ 'cars' | translate }}
            </span>
            <div class="admin-pagination-buttons">
                <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1"
                        [attr.aria-label]="'Previous page' | translate" type="button">
                    <i class="material-icons">chevron_left</i>
                </button>
                <button (click)="goToPage(page)" *ngFor="let page of getVisiblePages()"
                        [attr.aria-current]="page === currentPage ? 'page' : null"
                        [class.active]="page === currentPage" type="button">{{ page }}
                </button>
                <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === getTotalPages()"
                        [attr.aria-label]="'Next page' | translate" type="button">
                    <i class="material-icons">chevron_right</i>
                </button>
            </div>
        </footer>
    </ng-container>
</div>
<ng-template #dialogsContainer></ng-template>
